// Extensions
import { Service } from "../service";

// Utilities
import * as easingPatterns from "./easing-patterns";
import { getContainer, getOffset } from "./util";

export default function goTo(_target, _settings) {
  const settings = {
    container:
      document.scrollingElement || document.body || document.documentElement,
    duration: 500,
    offset: 0,
    easing: "easeInOutCubic",
    ..._settings
  };
  const container = getContainer(settings.container);

  const startTime = performance.now();
  const targetLocation = getOffset(_target) - settings.offset;
  const startLocation = container.scrollTop;
  if (targetLocation === startLocation) return Promise.resolve(targetLocation);

  const ease =
    typeof settings.easing === "function"
      ? settings.easing
      : easingPatterns[settings.easing];

  if (!ease)
    throw new TypeError(`Easing function "${settings.easing}" not found.`);

  return new Promise(resolve =>
    requestAnimationFrame(function step(currentTime) {
      const timeElapsed = currentTime - startTime;
      const progress = Math.abs(
        settings.duration ? Math.min(timeElapsed / settings.duration, 1) : 1
      );

      container.scrollTop = Math.floor(
        startLocation + (targetLocation - startLocation) * ease(progress)
      );

      if (
        progress === 1 ||
        container.clientHeight + container.scrollTop === container.scrollHeight
      ) {
        return resolve(targetLocation);
      }

      requestAnimationFrame(step);
    })
  );
}

export class Goto extends Service {
  static property = "goTo";

  init(root, Vue) {
    Vue.prototype.$goTo = goTo;
    this.framework[Goto.property] = goTo;
  }
}
